(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairPreRegistrationsController', PhysicalFairPreRegistrationsController);

    /* @ngInject */
    function PhysicalFairPreRegistrationsController($filter, $scope, $state, $uibModal, toastr, SellerService, ExpoService, PhysicalFairService, $rootScope, CountriesNewService, TimezonesService, AdmService, /* TODO: TEMP; REMOVE THIS --> */ $http, API_BASE /* <-- */, CurrentUser, AclService) {

        var vm = this;


        vm.preApprovedList       = '';
        vm.queryFlag             = false;
        vm.exhibitorName         = '';
        vm.email                 = '';
        vm.expos                 = '';
        vm.expoSelected          = '';
        vm.setActiveSelected     = setActiveSelected;

        vm.seller                = '';
        vm.sellerSelected        = '';
        vm.active                = [{name:'All',value: -1}, {name:'Yes', value:1}, {name:'No', value:0}];
        vm.activeSelected        = {name:'No', value:0};
        vm.selectExpo            = selectExpo;
        vm.getByFilter           = getByFilter;
        vm.getSellers            = getSellers;
        vm.openEditModal         = openEditModal;
        vm.createAccount         = createAccount;
        vm.selectAccount         = selectAccount;
        vm.countResult           = 0;
        vm.clearForm             = clearForm;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function activate() {
            vm.selectExpo();
            vm.getSellers();
            vm.setActiveSelected();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function getSellers() {

            SellerService.getAll().then(function(response){
                vm.seller = response.data;
                vm.seller.unshift({id:0,name:"--- All ---"});
            }).catch(function(err) {

            });
            // PhysicalFairService.getAllSellers().then(function(response){
            //     vm.seller = response.data;
            //     vm.seller.unshift({id:0,name:"All"});
            // }).catch(function(err) {

            // });
        }

        function openEditModal(preApprovedItem) {

            $uibModal.open({
                templateUrl: 'templates/physicalfairs/reports/pre-registrations/edit/template.modal.html',
                controller: 'PhysicalFairPreApprovedModalController',
                controllerAs:'vm',
                resolve:
                {
                    preApprovedItem      : function () {
                        return preApprovedItem;
                    },
                    sellers               : function () {
                        return vm.seller;
                    }
                }
            });
        }

        function createAccount(preApprovedItem, type) {
            $uibModal.open({
                size: 'lg',
                backdrop  : 'static',
                keyboard  : false,
                templateUrl: 'templates/physicalfairs/reports/pre-registrations/account/create.modal.html',
                controller: ['$uibModalInstance', 'countries', 'timezones', function ($uibModalInstance, countries, timezones) {
                    var modal = this;
                    modal.cancel = $uibModalInstance.close;
                    modal.save = save;
                    modal.getEntityType = getEntityType;
                    modal.getFormView = getFormView;
                    modal.checkboxValidator = checkboxValidator;
                    modal.uploadPhoto = uploadPhoto;
                    modal.uploadHandler = uploadHandler;
                    modal.imageCrop = imageCrop;
                    modal.entity = {
                        user: {
                            email: preApprovedItem.email,
                            type: type,
                        },
                        profile: {
                            name: preApprovedItem.exhibitor_name,
                        },
                        video_url: ''
                    };
                    modal.croppedImage = '';

                    modal.countries = countries;
                    modal.timezones = timezones;

                    switch (modal.entity.user.type) {
                        case 'Government':
                            /* Do nothing */
                            break;
                        case 'Agency':
                            /* Do nothing */
                            break;
                        case 'Institution':
                            modal.entity.profile.show_contact = false;
                            modal.entity.user.preferences = [
                                {
                                    name: 'Students',
                                    value: 'relationship_with_students'
                                },
                                {
                                    name: 'Schools',
                                    value: 'relationship_with_institutions'
                                },
                                {
                                    name: 'Study Abroad Agencies',
                                    value: 'relationship_with_agents'
                                },
                            ];
                            modal.entity.profile.institutions_profile_types = [
                                {
                                    name: "Secondary Schools / Boarding Schools",
                                    value: 'boarding'
                                },
                                {
                                    name: "Bachelor's / Bachelor of Science / Community College / College / Technical",
                                    value: 'university'
                                },
                                {
                                    name: "Master's / PhD / Specialized Master's",
                                    value: 'graduate'
                                },
                                {
                                    name: "MBA Programs",
                                    value: 'mba'
                                },
                                {
                                    name: "Short term / University credit program / Extension",
                                    value: 'extension'
                                },
                                {
                                    name: "Language Courses",
                                    value: 'language'
                                },
                                {
                                    name: "Online Distance Learning",
                                    value: 'online'
                                },
                                {
                                    name: "Vocational / Career / Technical",
                                    value: 'vocational'
                                },
                            ];
                            break;
                        case 'Other':
                            modal.entity.user.others_services_for_students = [
                                {
                                    name: 'Airline tickets',
                                    id: '2'
                                },
                                {
                                    name: 'Associations and Consortiums',
                                    id: '24'
                                },
                                {
                                    name: 'Currency house (exchange/sell)',
                                    id: '18'
                                },
                                {
                                    name: 'Education Resources',
                                    id: '22'
                                },
                                {
                                    name: 'Immigration Services',
                                    id: '17'
                                },
                                {
                                    name: 'Insurance Services',
                                    id: '21'
                                },
                                {
                                    name: 'Medical Assistance',
                                    id: '9'
                                },
                                {
                                    name: 'Student Housing',
                                    id: '20'
                                },
                                {
                                    name: 'Visa broker',
                                    id: '19'
                                },
                                {
                                    name: 'Work Abroad',
                                    id: '16'
                                }
                            ];
                            break;
                        default:
                            /* Do nothing */
                            break;
                    }

                    function save() {
                        var fields = angular.copy(modal.entity);
                        fields.user.profile_picture = modal.croppedImage;
                        
                        switch (fields.user.type) {
                            case 'Government':
                                fields.profile.represent_country = fields.profile.represent_country.id;
                                fields.profile.based_country = fields.profile.based_country.id;
                                fields.profile.description_students = fields.profile.description;
                                delete fields.profile.description;
                                break;
                            case 'Agency':
                                var gmapsInfo = modal.entity.profile.city;
                                
                                fields.profile.description_students = fields.profile.description;
                                delete fields.profile.description;

                                fields.profile.place_id = gmapsInfo.place_id;
                                fields.profile.city = gmapsInfo.vicinity;
                                fields.profile.countries_id = gmapsInfo.address_components.filter(comp => comp.types.includes('country'))[0].short_name;
                                    
                                break;
                            case 'Institution':
                                fields.profile.countries_id = fields.profile.countries_id.id;
                                fields.user.preferences = fields.user.preferences.reduce(function(preferences, preference, i) {
                                    if (preference.selected) {
                                        preferences.push(preference.value);
                                    }
                                    return preferences;
                                }, new Array());
                                fields.profile.institutions_profile_types = fields.profile.institutions_profile_types.reduce(function(types, type, i) {
                                    if (type.selected) {
                                        types.push(type.value);
                                    }
                                    return types;
                                }, new Array());
                                break;
                            case 'Other':
                                fields.profile.countries_id = fields.profile.countries_id.id;
                                fields.user.others_services_for_students = fields.user.others_services_for_students.reduce(function(services, service, i) {
                                    if (service.selected) {
                                        services.push(service.id);
                                    }
                                    return services;
                                }, new Array());
                                break;
                            default:
                                /* Do nothing */
                                break;
                        }

                        $http({
                            method: 'POST',
                            url: API_BASE + '/users_accounts',
                            headers: { 'Content-Type': 'application/json; charset=UTF-8' },
                            data: fields,
                        }).then(function (res) {
                            toastr.success('Account successfully created.');
                            $state.go('root.physicalfairs.preRegistrations.register', {userId : res.data.id, prId : preApprovedItem.id}, {reload:true});
                            // vm.getByFilter();
                            modal.cancel();
                        }).catch(function (res) {
                            switch (res.data.message) {
                                case 'SQLSTATE[23000]':
                                    toastr.error('E-mail already taken, please use another one.');
                                    break;
                                default:
                                    toastr.error('Something went wrong. Please try again later.');
                                    break;
                            }
                        });
                    }
                    
                    function checkboxValidator(checkboxGroup) {
                        return !checkboxGroup.filter(function(service) {
                            return service.selected;
                        }).length;
                    };
                    
                    function getEntityType() {
                        return modal.entity.user.type;
                    }
                    
                    function getFormView() {
                        return 'templates/physicalfairs/reports/pre-registrations/account/form/form' + modal.entity.user.type + '.html';
                    }

                    function uploadPhoto() {
                        angular.element('#accountProfilePhoto').trigger('click');
                    }

                    function uploadHandler(e) {
                        if (e.currentTarget.files.length) {
                            var file = e.currentTarget.files[0];
                            var reader = new FileReader();
                            reader.onload = function (e) {
                                $scope.$apply(function() {
                                    modal.imageCrop(e.target.result);
                                });
                            };
                            reader.readAsDataURL(file);
                        }
                        angular.element(e.target).val(null);
                    }    

                    function imageCrop(uploaded) {
                        $uibModal.open({
                            size: 'sm',
                            backdrop  : 'static',
                            templateUrl: 'templates/physicalfairs/reports/pre-registrations/account/form/crop.modal.html',
                            controller: ['$uibModalInstance', function ($uibModalInstance) {
                                var cropModal = this;
                                cropModal.cancel = $uibModalInstance.close;
                                cropModal.save = save;
                                cropModal.uploaded = uploaded;

                                function save() {
                                    modal.croppedImage = cropModal.cropped;
                                    cropModal.cancel();
                                }
                            }],
                            controllerAs: 'cropModal',
                        });
                    }
                }],
                controllerAs: 'modal',
                resolve: {
                    countries: function() {
                        return CountriesNewService.getCountries().then(function(response){
                            return response.data;
                        });
                    },
                    timezones: function() {
                        return TimezonesService.getTimezones().then(function(response){
                            return response.data;
                        });
                    }
                }
            });
        }

        function selectAccount(preApprovedItem) {
            $uibModal.open({
                size: 'lg',
                templateUrl: 'templates/physicalfairs/reports/pre-registrations/account/select.modal.html',
                controller: ['$scope', '$uibModalInstance', '$controller', 'clients', function ($scope, $uibModalInstance, $controller, clients) {
                    var modal = $controller('FindClientsListController', {clients: clients });
                    modal.cancel = $uibModalInstance.close;
                    modal.register = register;
                    $scope.modal = modal;

                    function register(account) {
                        $state.go('root.physicalfairs.preRegistrations.register', {userId : account.id, prId : preApprovedItem.id}, {reload:true});
                        modal.cancel();
                    }
                }],
                resolve: {
                    clients: ['FindClientsService', function(FindClientsService) {
                        return FindClientsService.getAll();
                    }]
                },
            });
        }

        function getByFilter() {
            vm.query = {};

            if(vm.exhibitorName !== '') {
                vm.query['exhibitor_name'] = vm.exhibitorName;
            }

            if(vm.email !== '') {
                vm.query['email'] = vm.email;
            }

            if( vm.activeSelected.name !== 'All') {
                vm.query['active']   = vm.activeSelected.value;
            }

            if(typeof vm.sellerSelected !== 'undefined' &&  vm.sellerSelected.name !== 'All') {
                vm.query['seller']   = vm.sellerSelected.id;
            }

            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo'] = vm.expoSelected.id;
            }

            vm.query['page']            = vm.page;

            PhysicalFairService.getByFilterPreRegistrations(vm.query).then(function(response){
                vm.preApprovedList  = response.data.data;
                vm.queryFlag        = true;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {
            });
        }

        function clearForm() {
            vm.expoSelected = '';
            vm.exhibitorName = '';
            vm.email = '';
            vm.sellerSelected = '';
            vm.activeSelected = {name:'All', value: -1};
        }

        function setActiveSelected() {
            if(AclService.can('view_all_physical_fairs_pre_registrations')){
                vm.activeSelected = {name:'All', value: -1};
            } else {
                vm.activeSelected = {name:'No', value: 0};
                vm.getByFilter();
            }
        }

        activate();
    }

})();